import { createContext, useContext } from 'react';

import { Model, ExplorationMetadata, Metric } from '../explore/types';

export interface MetadataContext {
  models: Model[];
  explorations: ExplorationMetadata[];
  metrics: Metric[];
  getModel: (modelId: string) => Model;
}

const defaultContextValue = Symbol();

export const MetadataContext = createContext<MetadataContext | typeof defaultContextValue>(
  defaultContextValue,
);

export const useMetadataContext = () => {
  const context = useContext(MetadataContext);
  if (context === defaultContextValue) {
    throw new Error('useMetadataContext must be used within a MetadataContextProvider');
  }
  return context;
};
